import {
    ActionTypes,
    SetStringAction,
    SetArrayAction,
    User,
    SetUserAction,
    SetBooleanAction,
} from './types';

export function setAppName(appName: string): SetStringAction {
    return {
        type: ActionTypes.SET_APP_NAME,
        payload: appName
    }
}

export function updateCollections(collections: []): SetArrayAction {
    return {
        type: ActionTypes.UPDATE_COLLECTIONS,
        payload: collections
    }
}

export function updateArticles(articles: []): SetArrayAction {
    return {
        type: ActionTypes.UPDATE_ARTICLES,
        payload: articles
    }
}


export function setLoggedInUser(user: User): SetUserAction {
    return {
        type: ActionTypes.SET_LOGGED_IN_USER,
        payload: user
    }
}

export function setLoggedOut(): SetUserAction {
    return {
        type: ActionTypes.SET_LOGGED_IN_USER,
        payload: null
    }
}

export function setShowUnpublishedArticles(show: boolean): SetBooleanAction {
    return {
        type: ActionTypes.SET_SHOW_UNPUBLISHED_ARTICLES,
        payload: show
    }
}

export function setShowUnpublishedCollections(show: boolean): SetBooleanAction {
    return {
        type: ActionTypes.SET_SHOW_UNPUBLISHED_COLLECTIONS,
        payload: show
    }
}

export function updateMedia(media: []): SetArrayAction {
    return {
        type: ActionTypes.UPDATE_MEDIA,
        payload: media
    }
}
